import { computed } from 'mobx';

export default class WOStatusModel {
  id;
  store;

  constructor(store, ticketStatus) {
    this.store = store;
    this.id = +ticketStatus.id;
    this.caption = ticketStatus.caption;
    this.description = ticketStatus.description;
    this.color = ticketStatus.color;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      caption: this.caption,
      description: this.description,
      color: this.color,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.caption = json.caption;
    this.description = json.description;
    this.color = json.color;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/WorkOrder/WOStatusModel.js